export default __webpack_public_path__ + "static/media/node.js_2.7b2cc865.png";